import React from "react";
import "./footer.scss";
import {useTranslation} from "react-i18next";

const Footer = ({isTurneroBuText}) => {
  const {t} = useTranslation();
  return (
    <div className="footer-outer-wrapper">
      <div className="footer-text">
        <div style={{textAlign: "center"}}>
          <strong>{t(`preferentialText${isTurneroBuText}`)}:</strong>
          <span> {t(`footerText${isTurneroBuText}`)},</span>
        </div>
        <span style={{display: "block"}}>
          {t(`footerTextSecond${isTurneroBuText}`)}.
        </span>
      </div>
    </div>
  );
};

export default Footer;
